/* import __COLOCATED_TEMPLATE__ from './new-notify-slack-channel.hbs'; */
/* RESPONSIBLE TEAM: team-workflows */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

export default class NewNotifySlackChannel extends Component {
  @service appService;
  @service intl;

  get formatValue() {
    let actionData = this.args.action.actionData;

    // NEW API: prefer slack_channel_name
    if (actionData?.slack_channel_name) {
      return actionData.slack_channel_name.startsWith('#')
        ? actionData.slack_channel_name
        : `#${actionData.slack_channel_name}`;
    }

    return '';
  }

  get conversationDataAttribute() {
    return {
      name:
        this.formatValue ||
        this.intl.t(
          'operator.workflows.visual-builder.notify-slack-channel.new-settings.choose-channel-placeholder',
        ),
    };
  }
}
